<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <breadcrumb16></breadcrumb16>
    <!-- Page Content -->
    <div class="content">
      <div class="container booking">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="booking-doc-info d-flex" v-if="doctor != undefined">
                  <a href="javascript:void(0);" @click="doctorProfile()" class="booking-doc-img">
                    <img :src="loadImg(doctor.image)" alt="User Image" />
                  </a>
                  <div class="booking-info">
                    <h4>
                      <a href="javascript:void(0);" @click="doctorProfile()">{{ doctor.first_name }} {{ doctor.middle_name
                      }}
                        {{ doctor.last_name }}</a>
                    </h4>
                    <div class="rating">
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star"></i>
                      <span class="d-inline-block average-rating">35</span>
                    </div>
                    <p class="text-muted mb-0">
                      <i class="fas fa-map-marker-alt"></i> {{ doctor.city }}
                      {{ doctor.state }}
                    </p>
                  </div>
                  <div class="col-12 col-sm-4 col-md-4 text-sm-left ml-3">
                    <h4 class="ml-3 mt-3" v-if="count !== 1">Select Hospital</h4>
                    <h4 v-else class="ml-3" style="margin-top: 42px;"></h4>
                    <div class="col-sm-12 pr-0 offset-0">
                      <div class="form-group" v-if="count !== 1">
                        <v-select name="hospital_name" required="" label="hospital_name" style="width:100%;"
                          placeholder="Select Hospital" @input="onChangeHospital" :reduce="(option) => option.hospital"
                          :options="hospitals">
                        </v-select>
                      </div>
                      <div v-else>
                        <input type="text" class="form-control" :value="hospitals[0].hospital_name" disabled
                          style="background-color: #fff;">
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-4 col-md-4 text-sm-left">
                    <div class="row">
                      <div class="col-sm-12 pr-0 offset-0 ml-3">
                        <h4 class="ml-3 mt-3">Select Appointment Date</h4>
                      </div>
                      <div class="bookingrange btn btn-white btn-sm ml-5" style="width:100%;">
                        <VueDatePicker v-model="selected_date" placeholder="Choose date" color="#15558d"
                          :minDate="disabledDates" @onChange="get_slots" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Schedule Widget -->
            <div class="card booking-schedule schedule-widget" v-if="selected_object != undefined">
              <!-- Schedule Header -->
              <div class="schedule-header">
                <div class="row">
                  <div class="col-md-12">
                    <!-- Day Slot -->
                    <div class="day-slot" v-if="schedule_days.length > 0">
                      <ul v-if="selected_object != undefined">
                        <li v-for="(day, index) in schedule_days" :key="index" @click="change_date(day)"
                          :class="{ 'active-day': activeDay === day.day, 'selected-date': getDateForDay(day.day).fullDate === selected_date }">
                          <div>
                            <span>{{ day.day.substring(0, 3) }}</span>
                            <span class="slot-date">{{ getDateForDay(day.day).dateStr }}</span>
                          </div>
                        </li>

                      </ul>
                    </div>
                    <!-- /Day Slot -->
                  </div>
                </div>
              </div>

              <!-- /Schedule Header -->
              <!-- Schedule Content -->
              <div class="schedule-cont" v-if="slots != undefined">
                <div class="row">
                  <div class="col-md-12">
                    <!-- Time Slot -->
                    <div class="time-slot">
                      <ul>
                        <li class="ml-2 mb-1">Slot Number and Estimated Time</li>
                      </ul>
                      <ul class="clearfix">
                        <li v-for="(slot, index) in slots" :key="index">
                          <a :id="slot.name" class="timing" :class="active_slot === index ? 'active' : ''"
                            @click="set_slot(slot, index)" :disabled="slot.booked">
                            <span class="slot_number">{{ slot.slot_no }}</span> &nbsp;
                            <span>{{ slot.from_time.slice(0, 5) }}</span>
                            <!-- <span class="ml-1">Slot No - {{ index + 1 }}</span> -->
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- /Time Slot -->
                  </div>
                </div>
              </div>
              <div class="schedule-cont" v-else>
                <div class="row">
                  <div class="col-md-12" style="text-align: center;">
                    <!-- Time Slot -->
                    <div class="time-slot">
                      <ul class="clearfix">
                        <li style="color: red;">{{ not_data }}</li>
                      </ul>
                    </div>
                    <!-- /Time Slot -->
                  </div>
                </div>
              </div>
              <!-- /Schedule Content -->
            </div>
            <!-- /Schedule Widget -->
            <!-- Submit Section -->
            <div class="submit-section proceed-btn text-center mt-3"
              v-if="selected_object != undefined && selected_slot != undefined">
              <a class="btn btn-primary submit-btn" @click="book_apoointment">Book Appointment</a>
            </div>
            <!-- /Submit Section -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <layout-footer></layout-footer>
  </div>
</template>

<style scoped>
.aligninput {
  margin: 0 1rem 0 0;
}

.custom_class {
  max-width: 170px;
  text-align: left;
  width: 100%;
  float: right;
}

.timing {
  cursor: pointer;
}

.day-slot ul li {
  cursor: pointer;
}

.container.booking {
  min-height: 50vh;
}

a[disabled="disabled"] {
  pointer-events: none;
  cursor: default;
}
</style>

<script>
import CommonApi from "../../../services/CommonApi";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { mapState } from "vuex";
import moment from 'moment';

export default {
  data() {
    return {
      activeDay: "",
      count: 0,
      doctor: undefined,
      selected_date: undefined,
      disabledDates: new Date(),
      selected_object: undefined,
      next_days: [],
      slot_no: "",
      slots: undefined,
      selected_slot: undefined,
      encounter_modes: [],
      hospitals: [],
      appointment_type: '',
      selected_hospital: "",
      active_slot: undefined,
      schedule_days: [],
      new_hospital: "",
      not_data: "",
    };
  },
  components: {
    // Datepicker
    VueDatePicker,
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
    isHospitalFieldDisabled() {
      // Check if the count is 1 and the selected_hospital is empty
      return this.count === 1 && !this.selected_hospital;
    },
  },
  mounted() {
    this.get_doctor_profile();
    this.get_practitioner_service_unit_hospital();
    this.get_appointment_type();
    this.get_encounter_mode();
    this.fetchAvailabilityDays();
    this.get_slots();
    this.selected_date = moment().format("YYYY-MM-DD");

    $("#booking-from").datetimepicker({
      format: "DD/MM/YYYY",
      icons: {
        up: "fas fa-chevron-up",
        down: "fas fa-chevron-down",
        next: "fas fa-chevron-right",
        previous: "fas fa-chevron-left",
      },
    });

    // }
  },

  watch: {

    selected_date(newDate) {
      // Check if newDate is defined before calling get_slots
      if (newDate) {
        this.get_slots();
      }
    },
    // Watch for changes in the count property
    count(newCount) {
      if (newCount === 1 && this.hospitals.length > 0) {
        this.selected_hospital = this.hospitals[0].hospital;
      }
    },
  },
  methods: {

    getDateForDay(dayOfWeek) {
      const today = moment();
      const currentDayOfWeek = today.format('dddd');
      const dayDifference = (moment().day(dayOfWeek).day() + 7 - moment().day(currentDayOfWeek).day()) % 7;
      const dateForDay = today.add(dayDifference, 'days').format("YYYY-MM-DD");

      return {
        dateStr: today.format("D MMM YY"), // Displayed date format
        fullDate: dateForDay // Full date format for comparison
      };
    },

    async fetchAvailabilityDays() {
      let search = new URLSearchParams({
        practitioner: this.$route.params.name,
        hospital: this.new_hospital,
      });

      try {
        const res = await CommonApi.get_data(
          "sahaj.appointment.get_availability_days",
          search
        );

        if (res.data && res.data.length > 0) {
          this.schedule_days = res.data[0].schedule_days;
        } else {
          console.warn("No data returned for availability days");
        }
      } catch (error) {
        console.error("Error fetching availability days:", error);
      }
    },

    loadImg(imgPath, value) {
      return "https://develop-physio.kneexpert.in" + imgPath;
    },

    doctorProfile() {
      this.$router.push(`/doctor/profile/${this.$route.params.name}`);
    },

    onChangeHospital(e) {
      this.selected_hospital = e;
      this.active_slot = undefined;
      if (e === null) {
        this.selected_object = undefined;
        this.selected_date = undefined;
      } else {
        if (this.selected_date) {
          this.get_slots();
        }
      }
    },

    async get_slots() {
      this.slots = undefined;
      this.active_slot = undefined;
      this.next_days = [];
      this.selected_object = new Date(this.selected_date);
      for (var i = 0; i <= 6; i++) {
        var currentDate = new Date(this.selected_date);
        currentDate.setDate(this.selected_object.getDate() + i);
        this.next_days.push(currentDate);
      }

      let search = new URLSearchParams({
        date: this.selected_date,
        // practitioner: this.doctor.name,
        hospital:this.selected_hospital,
        practitioner: this.$route.params.name
      });
      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        if (res.message !== "Not Available") {
          let slots = res.data.slot_details;
          this.slots = slots.find(
            (x) => x.hospital === this.selected_hospital
          ).avail_slot;
        }
        else {
          this.not_data = res.data
          // this.$swal.fire({
          //     icon: "warning",
          //     title: "Warning",
          //     text: res.message,
          //     showConfirmButton: true,
          //   });
        }
      });
    },
    get_moment(obj) {
      return moment(obj);
    },
    set_slot(slot, index) {
      this.selected_slot = slot;
      this.active_slot = index;
      $("a.timing").removeClass("selected");
      $("#" + slot.name).addClass("selected");
    },
    async change_date(day) {
      this.selected_slot = undefined;
      this.slots = undefined;
      this.active_slot = undefined;
      $("a.timing").removeClass("selected");

      // Get the current day of the week
      const today = moment();
      const currentDayOfWeek = today.format('dddd');

      // Get the selected day of the week
      this.activeDay = day.day;
      const selectedDayOfWeek = day.day;

      // Calculate the difference in days between the selected day and today
      const dayDifference = (moment().day(selectedDayOfWeek).day() + 7 - moment().day(currentDayOfWeek).day()) % 7;

      // Add the difference in days to the selected_date
      this.selected_date = today.add(dayDifference, 'days').format("YYYY-MM-DD");
      this.selected_object = day;

      let search = new URLSearchParams({
        date: this.selected_date,
        practitioner: this.doctor.name,
      });

      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        let slots = res.data.slot_details;

        this.slots = slots.find(
          (x) => x.hospital === this.selected_hospital
        ).avail_slot;
      }
      )
    },

    async add_favourite_Doctor() {
      let data = {
        practitioner: this.$route.params.name,
        patient: this.user_id,
      };
      await CommonApi.post_data("sahaj.finalapi.favorite_doctor", data).then(
        (res) => { }
      );
    },

    async book_apoointment() {
      var tempPractitioner = {
        practitioner: this.$route.params.name,
        appointment_date: this.selected_date,
        appointment_time: this.selected_slot.from_time,
        slot_no: this.selected_slot.slot_no,
        appointment_type: this.appointment_type,
        hospital: this.selected_hospital,
      };

      if (!this.user_id) {
        this.$router.push({
          name: "login",
          params: { tempAppointment: tempPractitioner },
        });
        return;
      }
      this.$swal({
        text: "Booking your appointment...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      var apointment_booking_data = {
        patient: this.user_id,
        practitioner: this.doctor.name,
        appointment_date: this.selected_date,
        appointment_time: this.selected_slot.from_time,
        slot_no: this.selected_slot.slot_no,
        appointment_type: this.appointment_type,
        hospital: this.selected_hospital,
      };
      await CommonApi.post_data(
        "sahaj.finalapi.get_doctor_appointment",
        apointment_booking_data
      ).then((res) => {
        if (res.status_code == 500) {
          const dateParts = this.selected_date.split('-');
          const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: res.message,
            showConfirmButton: true,
          });
        } else {
          this.add_favourite_Doctor();
          const formattedTime = moment(this.selected_slot.from_time, 'HH:mm').format('hh:mm A');
          this.$swal.fire({
            icon: "success",
            title: "Appointment Booked Successfully!",
            text:
              "Appointment Booked with " +
              this.doctor.first_name +
              " " +
              this.doctor.last_name +
              " on " +
              this.get_moment(this.selected_object).format("D MMMM YYYY") +
              " " +
              formattedTime,
            showConfirmButton: true,
          }).then(() => {
            this.$router.push("/");
          })
        }
      });
    },
    async get_doctor_profile() {
      let search = new URLSearchParams({ name: this.$route.params.name });
      await CommonApi.get_data(
        "sahaj.finalapi.get_doctor_profile",
        search
      ).then((res) => {
        this.doctor = res.data[0];
        if (res.data.length === 0) {
          this.$router.push("/");
        }
      });
    },

    async get_appointment_type() {
      await CommonApi.get_data("sahaj.api.get_appointment_type").then((res) => {
        if (res && res.data.length) {
          this.appointment_type = res.data[2].name;
        }
      });
    },


    async get_practitioner_service_unit_hospital() {
      let search = new URLSearchParams({
        practitioner: this.$route.params.name,
      });

      try {
        const res = await CommonApi.get_data(
          "sahaj.appointment.get_practitioner_service_unit_hospital",
          search
        );

        if (res) {
          this.hospitals = res.data.hospitals;
          this.new_hospital = res.data.hospitals[0].hospital;
          this.count = res.data.count;

          // Call fetchAvailabilityDays after setting new_hospital
          await this.fetchAvailabilityDays();
        }
      } catch (error) {
        console.error("Error fetching practitioner service unit hospital:", error);
      }
    },

    async get_encounter_mode() {
      const params = new URLSearchParams();
      params.append("parent", this.user_id);
      await CommonApi.get_data("sahaj.api.get_encounter_mode", params).then(
        (res) => {
          if (res && res.status_code == 200) {
            this.encounter_modes = res.data;
          }
        }
      );
    },
  },
};
</script>


<style scoped>
@media (max-width: 768px) {

  /* Adjust styles for mobile view */
  .booking-doc-info {
    flex-direction: column;
  }

  .booking-info {
    margin-top: 10px;
  }

  /* Add more styles as needed */
}

.active {
  background-color: #66CDAA !important;
  border: 1px solid #66CDAA !important;
  color: #fff !important;
}

.slot_number {
  background-color: #4682B4;
  color: #fff;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 100%;
}


.selected-date {
  color: #66CDAA;
  /* Or any color you prefer */
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Booking.vue